export class TacticPlayerDto {
    playerId: number;
    position: number;
    side: number;
}